export type PartnershipCtaContext = "assistance" | "insurance" | "general";
export type AudienceCtaKey = "patients" | "doctors" | "assistance" | "insurance";

const partnershipSubjects: Record<PartnershipCtaContext, string> = {
  assistance: "Medical Assistance Company Partnership",
  insurance: "Insurance Provider Partnership",
  general: "Partnership Enquiry",
};

export function getPartnershipCtaHref(context: PartnershipCtaContext): string {
  return `mailto:info@dociohealth.com?subject=${encodeURIComponent(partnershipSubjects[context])}`;
}

export function getAudienceCtaHref(audience: AudienceCtaKey, appUrl: string): string {
  if (audience === "assistance" || audience === "insurance") {
    return getPartnershipCtaHref(audience);
  }

  return appUrl;
}

export function getFooterCtaHref(
  cta: "joinAsDoctor" | "partnerWithUs",
  appUrl: string,
): string {
  return cta === "partnerWithUs" ? getPartnershipCtaHref("general") : appUrl;
}
